export const DocumentsReducerInitialState = {
  signedDocumentsById: [],
  latestEsthieAgreementDocuments: [],
  allDocuments: [],
};
